import { FuelAccordionContainer, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { SecurityAnalysisColors, SecurityAnalysisTexts } from 'constants/enums/trucker';
import { DS_TOKENS } from 'constants/styled.contants';
import { IDocument, ITruckerProfileProps } from 'interfaces/profile.interface';
import React, { FC, useEffect, useState } from 'react';
import Item from './Item';

export const SecurityAnalysis: FC<{ data: ITruckerProfileProps }> = ({ data }) => {
  const getDocumentObject = (type: string): IDocument =>
    data?.securityAnalysis?.documents.filter((item) => item.description === type)[0];

  const getLabelColor = (status: keyof typeof SecurityAnalysisColors): string =>
    SecurityAnalysisColors[status] || SecurityAnalysisColors['NÃO INFORMADO'];

  const [cnh, setCnh] = useState<IDocument>();
  const [cpf, setCpf] = useState<IDocument>();
  const [selfie, setSelfie] = useState<IDocument>();
  const [address, setAddress] = useState<IDocument>();

  useEffect(() => {
    if (!data?.securityAnalysis?.documents) return;

    setCnh(getDocumentObject(SecurityAnalysisTexts.CNH));
    setAddress(getDocumentObject(SecurityAnalysisTexts.ENDERECO));
    setCpf(getDocumentObject(SecurityAnalysisTexts.CPF));
    setSelfie(getDocumentObject(SecurityAnalysisTexts.SELFIE));
  }, [data]);

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 'km6',
        customPadding: `${DS_TOKENS.spacing.km10} ${DS_TOKENS.spacing.km8}`,
        backgroundColor: DS_TOKENS.color.background.neutral.weak,
      }}
    >
      <FuelTypography size="heading-sm" weight="bold" color="neutral-strong" data-testid="rating-title">
        Análise de Segurança
      </FuelTypography>

      <FuelAccordionContainer initialAccordion="1">
        <Item
          accordionItemId="1"
          accordionLabel="CNH"
          sectionName="cnh"
          eventName="trucker_profile_check_cnh"
          data={data}
          status={cnh?.status}
          tagColor={getLabelColor(cnh?.status)}
          contentText="Verificamos todos os itens da CNH na base do SENATRAN, como número do registro, data de emissão, validade, categoria, entre outros."
        />
        <Item
          accordionItemId="2"
          accordionLabel="CPF"
          sectionName="cpf"
          eventName="trucker_profile_check_cpf"
          data={data}
          status={cpf?.status}
          tagColor={getLabelColor(cpf?.status)}
          contentText="Verificamos se o status do CPF está regular na base da Receita Federal do Brasil."
        />
        <Item
          accordionItemId="3"
          accordionLabel="Validação da foto do motorista"
          sectionName="selfie"
          eventName="trucker_profile_check_foto"
          data={data}
          status={selfie?.status}
          tagColor={getLabelColor(selfie?.status)}
          contentText="Através de Inteligência Artificial, verifica-mos na hora da captura da selfie se a pessoa está ao vivo no momento da foto, atribuindo maior segurança."
        />
        <Item
          accordionItemId="4"
          accordionLabel="Endereço"
          sectionName="address"
          eventName="trucker_profile_check_endereco"
          data={data}
          status={address?.status}
          tagColor={getLabelColor(address?.status)}
          contentText="Verificamos se o endereço fornecido pelo motorista existe."
        />
      </FuelAccordionContainer>
    </FuelFlex>
  );
};

export default SecurityAnalysis;
